// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import SweetAlert from '../../Shared/Notification';
// import OptionModal from './../../Modals/OptionModal';
// import { useNavigate, useParams } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader';
// import { BackButton } from '../../Shared/BackButton';
// import {
//   Form,
//   Button,
//   Row,
//   Col,
//   FormControl,
//   FormGroup,
//   FormCheck,
//   FormLabel,
// } from 'react-bootstrap';
// import SelectDropdown from '../../Shared/SelectDropdown';
// import ErrorWrapper from '../../Shared/ErrorWrapper/index';

// const CreateType = () => {
//   const navigation = useNavigate();
//   const params = useParams();
//   const baseInventoryId = params.baseInventoryId;
//   const [state, setState] = useState({
//     name: '',
//     base_attributes: [{ name: '', type: '', is_required: false }],
//     showOptionModal: false,
//     attributeOptions: [''],
//     attributeInfo: {},
//     inventory_type: 'space_based',
//     isDisabled: false,
//     errors: {},
//   });

//   const optionStyle = {
//     fontSize: '12px',
//     margin: '0',
//     marginTop: '5px',
//     textDecoration: 'underline',
//     cursor: 'pointer',
//   };

//   const AttributeTypes = [
//     { value: 'FLOAT', label: 'Float' },
//     { value: 'STRING', label: 'Text' },
//     { value: 'DROPDOWN', label: 'Dropdown' },
//     { value: 'EMAIL', label: 'Email' },
//     { value: 'MULTISELECT', label: 'Multi Select' },
//   ];

//   // Get attribute type option from string
//   const getAttributeTypeOption = (value) => {
//     for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
//       if (AttributeTypes[i].value === value) {
//         return AttributeTypes[i];
//       }
//     }
//     return null;
//   };

//   const validate = (data) => {
//     const errors = {};
//     if (!data.name.trim()) {
//       errors.name = {
//         message: 'Please enter a name for base booking',
//       };
//     }

//     for (let i = 0; i < data.base_attributes.length; i++) {
//       let attr = 'attribute' + i;
//       let type = 'type' + i;
//       if (!data.base_attributes[i].name) {
//         errors[attr] = {
//           message: 'This field should not be blank',
//         };
//       }

//       if (!data.base_attributes[i].type) {
//         errors[type] = {
//           message: 'Please select the type',
//         };
//       }

//       if (
//         (data.base_attributes[i].type == 'DROPDOWN' ||
//           data.base_attributes[i].type == 'HASHTAG' ||
//           data.base_attributes[i].type == 'MULTISELECT') &&
//         (!data.base_attributes[i].hasOwnProperty('options') ||
//           data.base_attributes[i].options.length == 0 ||
//           data.base_attributes[i].options.indexOf('') > -1)
//       ) {
//         let opt = 'options' + i;
//         errors[opt] = {
//           message: 'Please fill the options',
//         };
//       }
//     }

//     return errors;
//   };

//   const onCancelOptionModal = () => {
//     setState({
//       ...state,
//       showOptionModal: false,
//       attributeOptions: [''],
//       attributeInfo: {},
//     });
//   };

//   const onSubmitOptionModal = (options, attributeInfo) => {
//     setState({
//       ...state,
//       showOptionModal: false,
//       attributeOptions: [''],
//       attributeInfo: {},
//     });

//     let newAttributes = Object.assign({}, attributeInfo.attribute, {
//       type: attributeInfo.attributeType,
//       options: options,
//     });
//     handleAttributeChange(newAttributes, attributeInfo.attrIndex);
//   };

//   const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
//     setState({
//       ...state,
//       showOptionModal: true,
//       attributeOptions: options,
//       attributeInfo: {
//         attributeType,
//         attribute,
//         attrIndex,
//       },
//     });
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     const isDisabled = state.isDisabled;
//     let value = isDisabled;
//     setState({
//       ...state,
//       isDisabled: !value,
//     });

//     const errors = validate(state);
//     if (Object.keys(errors).length) {
//       setState({
//         ...state,
//         errors,
//       });
//     } else if (!baseInventoryId) {
//       let data = state;
//       let res = await APIService.post(`/v0/ui/dynamic-inventory/base-inventory/`, data);
//       if (res.status == 200) {
//         setState({
//           ...state,
//           isDisabled: value,
//         });
//         SweetAlert('Base Inventory created successfully', 'success');
//         navigation(`/r/inventory/base/list`);
//       }
//     } else {
//       let req_data = {
//         name: state.name,
//         base_attributes: state.base_attributes,
//         inventory_type: 'space_based',
//       };
//       let res = await APIService.put(
//         `/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`,
//         req_data
//       );
//       if (res.status == 200) {
//         SweetAlert('Base Inventory updated successfully', 'success');
//         navigation(`/r/inventory/base/list`);
//       }
//     }
//   };

//   const onAddAttribute = () => {
//     const newAttributes = state.base_attributes.slice();
//     newAttributes.push({
//       name: '',
//       type: '',
//       is_required: false,
//     });
//     setState({
//       ...state,
//       base_attributes: newAttributes,
//     });
//   };

//   const onRemoveAttribute = (index) => {
//     const newAttributes = state.base_attributes.slice();
//     newAttributes.splice(index, 1);
//     setState({
//       ...state,
//       base_attributes: newAttributes,
//     });
//   };

//   const handleAttributeChange = (attribute, index) => {
//     const attributes = state.base_attributes.slice();
//     attributes.splice(index, 1, attribute);
//     setState({
//       ...state,
//       base_attributes: attributes,
//     });
//   };

//   const handleInputChange = (e) => {
//     setState({
//       ...state,
//       [e.target.name]: e.target.value,
//     });
//   };
//   const getBaseInventoryById = async (baseInventoryId) => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`);
//     if (res.status == 200) {
//       console.log(res.data);
//       setState({
//         ...state,
//         base_attributes: res.data.base_attributes,
//         selectedBaseInventoryId: res.data._id,
//         name: res.data.name,
//       });
//     }
//   };

//   const renderAttributeRow = (attribute, attrIndex) => {
//     const { errors } = state;

//     const onNameChange = (event) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.name = event.target.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onTypeChange = (item) => {
//       if (item.value === 'DROPDOWN' || item.value === 'MULTISELECT') {
//         setState({
//           ...state,
//           showOptionModal: true,
//           columnOptions: [''],
//           attributeInfo: {
//             attributeType: item.value,
//             attribute,
//             attrIndex,
//           },
//         });
//       }
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.type = item.value;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     const onRequiredChange = (event) => {
//       const newAttribute = Object.assign({}, attribute);
//       newAttribute.is_required = !!event.target.checked;
//       handleAttributeChange(newAttribute, attrIndex);
//     };

//     return (
//       <Row key={`row-${attrIndex}`}>
//         <Col>
//           <FormGroup className="my-2">
//             <Form.Control
//               type="text"
//               placeholder="Name"
//               value={attribute.name}
//               onChange={onNameChange}
//               className={{ error: errors['attribute' + attrIndex] }}
//             />
//           </FormGroup>
//           {errors && errors['attribute' + attrIndex] ? (
//             <ErrorWrapper error={errors['attribute' + attrIndex].message} />
//           ) : null}
//         </Col>

//         <Col>
//           <SelectDropdown
//             optionsData={AttributeTypes}
//             isClearable={false}
//             id={`row-${attrIndex}`}
//             classNamePrefix="form-select"
//             selectedValue={getAttributeTypeOption(attribute.type)}
//             handleSelect={onTypeChange}
//           />
//           {attribute.type === 'DROPDOWN' || attribute.type === 'MULTISELECT' ? (
//             <p
//               className="show-option"
//               style={optionStyle}
//               onClick={() =>
//                 onOpenOptionModal(attribute.options, attribute.type, attribute, attribute.attrIndex)
//               }
//             >
//               Show Options
//             </p>
//           ) : (
//             ''
//           )}
//           {errors && errors['options' + attrIndex] ? (
//             <ErrorWrapper error={errors['options' + attrIndex].message} />
//           ) : null}
//           {errors && errors['type' + attrIndex] ? (
//             <ErrorWrapper error={errors['type' + attrIndex].message} />
//           ) : null}
//         </Col>
//         <Col>
//           <FormGroup className="inline my-1.5 border border-primary p-2">
//             <Form.Check
//               type="checkbox"
//               name="option"
//               label={'Is it required ?'}
//               value={attribute.is_required}
//               checked={attribute.is_required}
//               onChange={onRequiredChange}
//             />
//           </FormGroup>
//         </Col>
//         <Col>
//           <Button
//             type="button"
//             className="btn btn-primary mt-1"
//             onClick={() => onRemoveAttribute(attrIndex)}
//           >
//             Remove Attribute
//           </Button>
//         </Col>
//       </Row>
//     );
//   };

//   // const { isDisabled, errors } = state;
//   const backButton = () => {
//     return <BackButton onClick={() => navigation(`/r/inventory/base/list`)} />;
//   };
//   useEffect(() => {
//     if (baseInventoryId) getBaseInventoryById(baseInventoryId);
//   }, []);
//   return (
//     <>
//       <TableHeader
//         headerValue={`${baseInventoryId ? 'Edit' : 'Create'} - Inventory Standard Template`}
//         isBackButton={backButton}
//       />
//       <Form onSubmit={onSubmit}>
//         <Col>
//           <FormGroup>
//             <Form.Label>
//               Enter Name For Base Inventory <span className="required-field">*</span>
//             </Form.Label>
//             <FormControl
//               type="text"
//               name="name"
//               placeholder="Enter Name For Base Inventory"
//               value={state.name}
//               onChange={handleInputChange}
//               isInvalid={!!state.errors.name}
//             />
//             <FormControl.Feedback type="invalid">
//               {state?.errors?.name && <ErrorWrapper error={state?.errors.name?.message} />}
//             </FormControl.Feedback>
//           </FormGroup>
//         </Col>
//         <Form.Label className="form-label">Attributes</Form.Label>
//         <div>{state.base_attributes.map(renderAttributeRow)}</div>
//         <Button variant="primary" onClick={onAddAttribute} style={{ marginRight: '10px' }}>
//           Add Attribute
//         </Button>
//         <Button type="submit" variant="primary">
//           Submit
//         </Button>
//       </Form>
//       <OptionModal
//         key={state.attributeInfo.attrIndex}
//         showOptionModal={state.showOptionModal}
//         onCancel={onCancelOptionModal}
//         onSubmit={onSubmitOptionModal}
//         options={state.attributeOptions}
//         columnInfo={state.attributeInfo}
//       />
//     </>
//   );
// };
// export default CreateType;

import React, { useEffect, useState } from 'react';
import SweetAlert from '../../Shared/Notification';
import OptionModal from './../../Modals/OptionModal.tsx';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { BackButton } from '../../Shared/BackButton';
import ErrorWrapper from '../../Shared/ErrorWrapper/index';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';

const CreateType = () => {
  const navigation = useNavigate();
  const params = useParams();
  const { showSnackBar } = useSnackBar();
  const baseInventoryId = params.baseInventoryId;
  const [state, setState] = useState({
    name: '',
    base_attributes: [{ name: '', type: '', is_required: false }],
    showOptionModal: false,
    attributeOptions: [''],
    attributeInfo: {},
    inventory_type: 'space_based',
    isDisabled: false,
    errors: {},
  });

  const optionStyle = {
    fontSize: '12px',
    margin: '0',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
  };

  const AttributeTypes = [
    { value: 'FLOAT', label: 'Float' },
    { value: 'STRING', label: 'Text' },
    { value: 'DROPDOWN', label: 'Dropdown' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'MULTISELECT', label: 'Multi Select' },
  ];

  const getAttributeTypeOption = (value) => {
    for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
      if (AttributeTypes[i].value === value) {
        return AttributeTypes[i];
      }
    }
    return null;
  };

  const validate = (data) => {
    const errors = {};
    if (!data.name.trim()) {
      errors.name = {
        message: 'Please enter a name for base booking',
      };
    }

    for (let i = 0; i < data.base_attributes.length; i++) {
      let attr = 'attribute' + i;
      let type = 'type' + i;
      if (!data.base_attributes[i].name) {
        errors[attr] = {
          message: 'This field should not be blank',
        };
      }

      if (!data.base_attributes[i].type) {
        errors[type] = {
          message: 'Please select the type',
        };
      }

      if (
        (data.base_attributes[i].type == 'DROPDOWN' ||
          data.base_attributes[i].type == 'HASHTAG' ||
          data.base_attributes[i].type == 'MULTISELECT') &&
        (!data.base_attributes[i].hasOwnProperty('options') ||
          data.base_attributes[i].options.length == 0 ||
          data.base_attributes[i].options.indexOf('') > -1)
      ) {
        let opt = 'options' + i;
        errors[opt] = {
          message: 'Please fill the options',
        };
      }
    }

    return errors;
  };

  const onCancelOptionModal = () => {
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });
  };

  const onSubmitOptionModal = (options, attributeInfo) => {
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });

    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      type: attributeInfo.attributeType,
      options: options,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
  };

  const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
    setState({
      ...state,
      showOptionModal: true,
      attributeOptions: options,
      attributeInfo: {
        attributeType,
        attribute,
        attrIndex,
      },
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const isDisabled = state.isDisabled;
    let value = isDisabled;
    setState({
      ...state,
      isDisabled: !value,
    });

    const errors = validate(state);
    if (Object.keys(errors).length) {
      setState({
        ...state,
        errors,
      });
    } else if (!baseInventoryId) {
      let data = state;
      let res = await APIService.post(`/v0/ui/dynamic-inventory/base-inventory/`, data);
      if (res.status == 200) {
        setState({
          ...state,
          isDisabled: value,
        });
        showSnackBar('Base Inventory created successfully', 'success');
        navigation(`/r/inventory/base/list`);
      }
    } else {
      let req_data = {
        name: state.name,
        base_attributes: state.base_attributes,
        inventory_type: 'space_based',
      };
      let res = await APIService.put(
        `/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`,
        req_data
      );
      if (res.status == 200) {
        showSnackBar('Base Inventory updated successfully', 'success');
        navigation(`/r/inventory/base/list`);
      }
    }
  };

  const onAddAttribute = () => {
    const newAttributes = state.base_attributes.slice();
    newAttributes.push({
      name: '',
      type: '',
      is_required: false,
    });
    setState({
      ...state,
      base_attributes: newAttributes,
    });
  };

  const onRemoveAttribute = (index) => {
    const newAttributes = state.base_attributes.slice();
    newAttributes.splice(index, 1);
    setState({
      ...state,
      base_attributes: newAttributes,
    });
  };

  const handleAttributeChange = (attribute, index) => {
    const attributes = state.base_attributes.slice();
    attributes.splice(index, 1, attribute);
    setState({
      ...state,
      base_attributes: attributes,
    });
  };

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const getBaseInventoryById = async (baseInventoryId) => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`);
    if (res.status == 200) {
      console.log(res.data);
      setState({
        ...state,
        base_attributes: res.data.base_attributes,
        selectedBaseInventoryId: res.data._id,
        name: res.data.name,
      });
    }
  };

  const renderAttributeRow = (attribute, attrIndex) => {
    const { errors } = state;

    const onNameChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.name = event.target.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onTypeChange = (item) => {
      const newAttribute = { ...attribute };

      if (!item) {
        newAttribute.type = '';
        handleAttributeChange(newAttribute, attrIndex);
        return;
      }

      if (item.value === 'DROPDOWN' || item.value === 'MULTISELECT') {
        setState((prev) => ({
          ...prev,
          showOptionModal: true,
          columnOptions: [''],
          attributeInfo: {
            attributeType: item.value,
            attribute,
            attrIndex,
          },
        }));
      }

      newAttribute.type = item.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onRequiredChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.is_required = !!event.target.checked;
      handleAttributeChange(newAttribute, attrIndex);
    };

    return (
      <Grid container spacing={2} key={`row-${attrIndex}`} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            type="text"
            slotProps={{
              inputLabel: {
                sx: { top: '-7px' }
              }
            }}
            label={
              <span>
                Name<span style={{ color: 'red' }}> *</span>
              </span>
            }
            value={attribute.name}
            onChange={onNameChange}
            error={Boolean(errors?.['attribute' + attrIndex])}
            helperText={errors?.['attribute' + attrIndex]?.message}
            InputProps={{
              sx: {
                '& input': {
                   padding: '8px',
                },
              },
            }}
            sx={{mt:1}}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <SearchableDropdown
            options={AttributeTypes}
            value={getAttributeTypeOption(attribute.type)}
            onChange={onTypeChange}
            label={
              <span>
                Attribute Type<span style={{ color: 'red' }}> *</span>
              </span>
            }
            valueKey="value"
            labelKey="label"
            size="small"
            error={Boolean(errors?.['type' + attrIndex])}
            errorMessage={errors?.['type' + attrIndex]?.message}
            disabled={false}
          />

          {['DROPDOWN', 'MULTISELECT'].includes(attribute.type) && (
            <Typography
              variant="body2"
              sx={{ ...optionStyle, cursor: 'pointer', mt: 1 }}
              onClick={() =>
                onOpenOptionModal(attribute.options, attribute.type, attribute, attribute.attrIndex)
              }
            >
              Show Options
            </Typography>
          )}

          {errors?.['options' + attrIndex] && (
            <ErrorWrapper error={errors['options' + attrIndex].message} />
          )}
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={attribute.is_required}
                onChange={onRequiredChange}
                name="is_required"
              />
            }
            label="Is it required?"
          />
        </Grid>

        <Grid xs={12} sm={3} sx={{ px: { xs: 2, sm: 0 }, mt: 2 }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => onRemoveAttribute(attrIndex)}
          >
            Remove Attribute
          </Button>
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    if (baseInventoryId) getBaseInventoryById(baseInventoryId);
  }, []);
  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            {`${baseInventoryId ? 'Edit' : 'Create'} - Inventory Standard Template`}
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/inventory/base/list`)} />
        </Grid>
      </Grid>
      <Box component="form" onSubmit={onSubmit} noValidate>
        <Grid container sx={{ mt: 1, gap: 2 }}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Enter Name For Base Inventory <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="name"
              placeholder="Enter Name For Base Inventory"
              value={state.name}
              onChange={handleInputChange}
              error={Boolean(state.errors?.name)}
              helperText={state.errors?.name?.message}
              InputProps={{
                sx: {
                  '& input': {
                    padding: '8px',
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6">Attributes</Typography>
            <Box>{state.base_attributes.map(renderAttributeRow)}</Box>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" onClick={onAddAttribute} sx={{ mr: 2 }}>
              Add Attribute
            </Button>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <OptionModal
        key={state.attributeInfo.attrIndex}
        showOptionModal={state.showOptionModal}
        onCancel={onCancelOptionModal}
        onSubmit={onSubmitOptionModal}
        options={state.attributeOptions}
        columnInfo={state.attributeInfo}
      />
    </Box>
  );
};
export default CreateType;
